export default JSON.stringify({
  refreshToken: 'asgsdfgs',
  data: [
    {
      email: 'user@test.com',
      id: 'testuser01',
    },
    {
      email: 'user2@test.com',
      id: 'testuser02',
    },
  ],
})
